import { createAction, props } from '@ngrx/store';

import { ItemsPagination } from 'src/app/model/api/data-rest';
import { EventMessage, EventType } from 'src/app/model/event-message';
import { MailNotificationConfig, NotifyAdvanceConfig } from 'src/app/model/mail-notification-config';
import { ManeuverNotificationConfig } from 'src/app/model/maneuver-notification-config';

export const getEvents = createAction('GET_EVENTS', props<{
    userId?: number;
    language?: string;
}>());
export const getEventsSuccess = createAction('GET_EVENTS_SUCCESS', props<{ paging: ItemsPagination; events: EventMessage[] }>());
export const getEventsFailed = createAction('GET_EVENTS_FAILED', props<{ errorMessage: string }>());

export const getEventsAllReset = createAction('GET_EVENTS_ALL_RESET');
export const getEventsAll = createAction('GET_EVENTS_ALL', props<{
    userId?: number;
    language?: string;
}>());
export const getEventsAllSuccess = createAction('GET_EVENTS_ALL_SUCCESS', props<{ paging: ItemsPagination; events: EventMessage[] }>());
export const getEventsAllFailed = createAction('GET_EVENTS_ALL_FAILED', props<{ errorMessage: string }>());

export const setPagination = createAction('[Events] SET_PAGINATION', props<{
    page?: number; size?: number; sort?: string; order?: string;
}>());
export const resetFilter = createAction('[Events] Reset_FILTER');
export const setFilter = createAction('[Events] SET_FILTER', props<{
    deviceId?: number; typeId?: number; startDate?: Date; endDate?: Date;
}>());

export const getEventTypes = createAction('GET_EVENT_TYPES');
export const getEventTypesSuccess = createAction('GET_EVENT_TYPES_SUCCESS', props<{ eventTypes: EventType[] }>());
export const getEventTypesFailed = createAction('GET_EVENT_TYPES_FAILED', props<{ errorMessage: string }>());

export const getEmailConfigs = createAction('GET_EMAIL_CONFIGS');
export const getEmailConfigsSuccess = createAction('GET_EMAIL_CONFIGS_SUCCESS', props<{ emailConfigs: MailNotificationConfig[] }>());
export const getEmailConfigsFailed = createAction('GET_EMAIL_CONFIGS_FAILED', props<{ errorMessage: string }>());

export const saveEmailConfigs = createAction('SAVE_EMAIL_CONFIGS', props<{ deviceId?: number; level: number }>());
export const saveEmailConfigsSuccess = createAction('SAVE_EMAIL_CONFIGS_SUCCESS', props<{ message: string }>());
export const saveEmailConfigsFailed = createAction('SAVE_EMAIL_CONFIGS_FAILED', props<{ errorMessage: string }>());

export const deleteEmailConfigs = createAction('DELETE_EMAIL_CONFIGS', props<{ configId: number }>());
export const deleteEmailConfigsSuccess = createAction('DELETE_EMAIL_CONFIGS_SUCCESS', props<{ message: string }>());
export const deleteEmailConfigsFailed = createAction('DELETE_EMAIL_CONFIGS_FAILED', props<{ errorMessage: string }>());


export const getManeuversNotifConfigs = createAction('GET_MANEUVERS_NOTIF_CONFIGS', props<{ deviceId: number }>());
export const getManeuversNotifConfigsSuccess = createAction(
    'GET_MANEUVERS_NOTIF_CONFIGS_SUCCESS',
    props<{ maneuverConfigs: ManeuverNotificationConfig[] }>()
);
export const getManeuversNotifConfigsFailed = createAction(
    'GET_MANEUVERS_NOTIF_CONFIGS_FAILED',
    props<{ errorMessage: string }>()
);

export const createManeuversNotifConfig = createAction('CREATE_MANEUVERS_NOTIF_CONFIG', props<{ config: ManeuverNotificationConfig }>());
export const createManeuversNotifConfigSuccess = createAction(
    'CREATE_MANEUVERS_NOTIF_CONFIG_SUCCESS',
    props<{ config: ManeuverNotificationConfig; message: string }>()
);
export const createManeuversNotifConfigFailed = createAction('CREATE_MANEUVERS_NOTIF_CONFIG_FAILED', props<{ errorMessage: string }>());

export const updateManeuversNotifConfig = createAction('UPDATE_MANEUVERS_NOTIF_CONFIG', props<{ config: ManeuverNotificationConfig }>());
export const updateManeuversNotifConfigSuccess = createAction(
    'UPDATE_MANEUVERS_NOTIF_CONFIG_SUCCESS',
    props<{ config: ManeuverNotificationConfig; message: string }>()
);
export const updateManeuversNotifConfigFailed = createAction('UPDATE_MANEUVERS_NOTIF_CONFIG_FAILED', props<{ errorMessage: string }>());

export const deleteManeuversNotifConfig = createAction('DELETE_MANEUVERS_NOTIF_CONFIG', props<{ configId: number }>());
export const deleteManeuversNotifConfigSuccess = createAction('DELETE_MANEUVERS_NOTIF_CONFIG_SUCCESS', props<{ message: string }>());
export const deleteManeuversNotifConfigFailed = createAction('DELETE_MANEUVERS_NOTIF_CONFIG_FAILED', props<{ errorMessage: string }>());

export const notificationDialogReset = createAction('NOTIFICATION_DIALOG_RESET');

export const getNotifyAdvanceDevice = createAction('GET_NOTIFY_ADVANCE_DEVICE', props<{ deviceId: number, ownerId?: number }>());
export const getNotifyAdvanceDeviceSuccess = createAction('GET_NOTIFY_ADVANCE_DEVICE_SUCCESS', props<{ listNotifyConfig: NotifyAdvanceConfig[] }>());
export const getNotifyAdvanceDeviceFailed = createAction('GET_NOTIFY_ADVANCE_DEVICE_FAILED', props<{ errorMessage: string }>());

export const editNotifyAdvanceDevice = createAction('EDIT_NOTIFY_ADVANCE_DEVICE', props<{ deviceId: number, notify: NotifyAdvanceConfig, ownerId?: number }>());
export const editNotifyAdvanceDeviceSuccess = createAction('EDIT_NOTIFY_ADVANCE_DEVICE_SUCCESS', props<{ message: string, deviceId: number, ownerId?: number }>());
export const editNotifyAdvanceDeviceFailed = createAction('EDIT_NOTIFY_ADVANCE_DEVICE_FAILED', props<{ errorMessage: string, deviceId: number, ownerId?: number }>());

export const deleteEmailEventsNotifications = createAction('DELETE_EMAIL_EVENTS_NOTIFICATIONS', props<{ token: string }>());
export const deleteEmailEventsNotificationsSuccess = createAction('DELETE_EMAIL_EVENTS_NOTIFICATIONS_SUCCESS', props<{ message: string }>());
export const deleteEmailEventsNotificationsFailed = createAction('DELETE_EMAIL_EVENTS_NOTIFICATIONS_FAILED', props<{ errorMessage: string }>());
